
















































































































































































































import {Prop, Ref, Vue, Watch} from 'vue-property-decorator';
import Map from '../components/Dashboard/Map.vue';
import BButton from 'buefy/src/components/button/Button.vue';
import DashboardNavBar from '../components/Dashboard/DashboardNavBar.vue';
import Component, {mixins} from 'vue-class-component';
import {Comparer, MAFUser, Purchase, UserTransaction} from '@/store/User/types';
import { violationState } from '@/store/Violations';
import {Action, Mutation, namespace, State} from 'vuex-class';
import BModal from 'buefy/src/components/modal/Modal.vue';
import ModalTemplate from '@/components/common/ModalTemplate.vue';
import CurrentLocation from '@/mixins/CurrentLocation';
import {AddressComponent, PlaceDetailsResult, PlaceSearchResult} from '@google/maps';
import VerifyModalBody from '@/components/Dashboard/VerifyModalBody.vue';
import {modalTemplate} from '@/components/common/types';
import ChatBox from '@/components/Dashboard/ChatBox.vue';
import UserChatView from '@/components/Dashboard/UserChatView.vue';
import MeetUpCreationModal from '@/components/Dashboard/MeetUpCreationModal.vue';
import * as firebase from 'firebase/app';
import * as _ from 'lodash';
import GeoPoint = firebase.firestore.GeoPoint;
import geohash from 'ngeohash';


import SlideOutChatContainer from '@/components/Dashboard/SlideOutChatContainer.vue';
import {slideOutChatContainer} from '@/components/Dashboard/types';
import {Meetup, message} from '@/store/Friends/types';
import CurrentMeetUpModal from '@/components/Dashboard/CurrentMeetUpModal.vue';
import CoinBody from '../components/Modals/CoinModals/CoinBody.vue';
import CoinFooter from '@/components/Modals/CoinModals/CoinFooter.vue';
import CoinTitle from '@/components/Modals/CoinModals/CoinTitle.vue';
import ShareRateBody from '../components/Modals/ShareRateModals/ShareRateBody.vue';
import GiftCoinsBody from '../components/Modals/GiftCoinsModal/GiftCoins.vue';
import PurchaseCoinsBody from '../components/Modals/PurchaseCoinsModal/PurchaseCoinsBody.vue';
import PaymentBody from '../components/Modals/PaymentModal/PaymentBody.vue';
import HelpBody from '../components/Modals/HelpModals/HelpBody.vue';
import ProfileUpdateModal from '../components/Modals/ProfileModals/ProfileUpdateModal.vue';
import Redeem500Modal from '../components/Modals/Redeem500Modal.vue';
import OnlineSafetyModal from '../components/Modals/onlineSafetyModal.vue';
import AvatarCreator from '@/components/SignUp/AvatarCreator.vue';
import UploadModal from '@/components/SignUp/UploadModal.vue';
import SettingModal from '@/components/Dashboard/SettingModal.vue';
import VideoChatModal from '@/components/Modals/VideoChatModal/VideoChatModal.vue';
import BlockUserModal from '@/components/Modals/BlockUserModal.vue';
import ReportUserModal from '@/components/Modals/ReportUserModal.vue';
import CovidTipsModal from '@/components/Modals/covidTipsModal.vue';
import NewMobileModal from '@/components/Modals/NewMobileModal.vue';
import { WebRTCRequest } from '../store/Friends/types';

/* tslint:disable:no-console */
const violationPath = 'violationState';
const violationNamespace = namespace(violationPath);
const userNamespace = namespace('userState');
const friendNamespace = namespace('friendState');
const rateNamespace = namespace('rateState');
@Component({
  components: {
    ProfileUpdateModal,
    HelpBody,
    CoinFooter,
    CoinTitle,
    AvatarCreator,
    CoinBody,
    CurrentMeetUpModal,
    UploadModal,
    SettingModal,
    MeetUpCreationModal,
    ChatBox,
    VerifyModalBody,
    Map,
    DashboardNavBar,
    BModal,
    ModalTemplate,
    SlideOutChatContainer,
    UserChatView,
    ShareRateBody,
    VideoChatModal,
    Redeem500Modal,
    OnlineSafetyModal,
    BlockUserModal,
    ReportUserModal,
    GiftCoinsBody,
    PurchaseCoinsBody,
    PaymentBody,
    CovidTipsModal,
    NewMobileModal,
  },
})
export default class Dashboard extends mixins(CurrentLocation) {
  @Prop(String) public readonly route!: string;
  @userNamespace.State('self') public self: MAFUser | undefined;
  @friendNamespace.State('messages') public messages!: message[];
  @friendNamespace.State('friends') public friends!: any[];
  @friendNamespace.State('currentlyChattingWith') public readonly friend!: MAFUser;
  @friendNamespace.State('toConnections') public readonly toConnections!: WebRTCRequest[];
  @violationNamespace.State('allUsers') public allUsers !: any[];
  @userNamespace.State('transactions') public readonly transactions!: UserTransaction[];
  @violationNamespace.Action('getAllUsers') public getAllUsers: any;

  @friendNamespace.Mutation('setFriends') public setFriends: any;

  @friendNamespace.Action('getFriendsNearMe') public getFriendsNearMe!: any;
  @friendNamespace.Action('getChatPrompts') public getChatPrompts!: any;
  @friendNamespace.Action('watchForConnections') public watchForConnections!: any;
  @friendNamespace.Action('watchForYourConnections') public watchForYourConnections!: any;
  @friendNamespace.Action('sendEmailNotification') public sendEmailNotification!: any;
  @rateNamespace.Action('getFAQs') public getFAQs!: any;
  @userNamespace.Action('getGroupActivities') public getGroupActivities: any;
  @friendNamespace.Action('getFriends') public getFriends: any;

  @friendNamespace.Action('getMyMeetups') public getMyMeetups!: any;
  @friendNamespace.Action('getMessages') public getMessages!: any;
  @userNamespace.Action('getActivities') public getActivities!: any;
  @userNamespace.Action('getDiagnosis') public getDiagnosis!: any;
  @userNamespace.Action('getUserType') public getUserType!: any;
  @friendNamespace.Mutation(`setCurrentlyChattingWith`) public setCurrentlyChattingWith!: any;

  @Ref('verifyModal') public verifyModal!: modalTemplate;
  @Ref('meetupModal') public meetupModal!: modalTemplate;
  @Ref('currentMeetupModal') public currentMeetupModal!: modalTemplate;
  @Ref('coinsModal') public coinsModal!: modalTemplate;
  @Ref('shareModal') public shareModal!: modalTemplate;
  @Ref('profileModal') public profileModal!: modalTemplate;
  @Ref('faqModal') public faqModal!: modalTemplate;
  @Ref('videoChatModal') public videoChatModal!: any;


  @Ref('chatBox') public chatBox!: slideOutChatContainer;

  public googleKey: string;
  public hasShown: boolean;
  public showChat: boolean;
  public showMeetups: boolean;
  public showCoins: boolean;
  public showShare: boolean;
  public showGiftCoins: boolean = false;
  public showPurchaseCoins: boolean = false;
  public showRedeemOffer: boolean = false;
  public showSafety: boolean = true;
  public showNewMobile: boolean = true;
  public showPayment: boolean = false;
  public showCurrentMeetups: boolean;
  public showFAQ: boolean = false;
  public showProfile: boolean = false;
  public showUploadModal: boolean = false;
  public showAvatarCreator: boolean = false;
  public showVideoChat: boolean = false;
  public showBlockUser: boolean = false;
  public showReportedUser: boolean = false;
  public showSettings: boolean;
  public chatType: string = 'Video';
  public selectedCoinPayment: any = {};
  public selectedFriend: string = '';

  public connectionRequests: WebRTCRequest[] = [];
  public nearbyFriends: any[] = [];
  public radius: number = 100;
  public limit: number = 100;
  public unsub: any;

  // chat information passed in from toast
  public incomingUser: any = [];
  public incomingConnection: any = [];

  /*public ads: any[] = [
    {
      imgUrl: require('../assets/ads/adMAFSoccer.png'),
      link: 'https://www.soccershots.org/LIWEST/',
    },
    {
      imgUrl: require('../assets/ads/adMAFGolf.png'),
      link: 'http://mafgolfouting.com/',
    },
    {
      imgUrl: require('../assets/ads/adAnchor.png'),
      link: 'https://anchor.fm/megan-carranza',
    },
    {
      imgUrl: require('../assets/ads/adMove.png'),
      link: 'https://moveinclusivedance.com/ ',
    },
    {
      imgUrl: require('../assets/ads/adPBS.png'),
      link: 'http://pbscommunityfoundation.org',
    },
  ];
  public adIdx: any = 0;*/

  constructor() {
    super();
    // todo: move this to environment variable
    this.googleKey = 'AIzaSyBCEv49x_5TxI3DjainSusoDCGiDRkCxq0';
    this.hasShown = false;
    this.showChat = false;
    this.showCoins = false;
    this.showMeetups = false;
    this.showShare = false;
    this.showCurrentMeetups = false;
    this.showSettings = false;
  }

  public async created() {
    this.determineChat();
    await this.getActivities();
    await this.getDiagnosis();
    await this.getUserType();
    await this.getFAQs();
    await this.getChatPrompts();
    await this.getGroupActivities();

    if (this.self) {
      this.watchForYourConnections(this.self.uid);
      this.watchForConnections(this.self.uid);
      await this.getMessages(this.self.uid);
      await this.getMyMeetups(this.self.uid);
    }
  }

  public async mounted() {
    try {
      // populate allUsers from DB for location checks later
      await this.getAllUsers();
    } catch (error) {
      console.log(error);
    }
    try {
      // get certain number of nearby friends
      await this.getNearbyFriends();
    } catch (error) {
      console.log(error);
    }

    // this.update();
  }

  // first 500 popup

  get hasFirst500() {
    const hasFirst500 = _.find(this.transactions, (t: UserTransaction) => t.purchase.what === 'first500');
    return !!hasFirst500;
  }

  @Watch('transactions')
  public showFirst500() {
    if (this.transactions && this.self && this.self.first500 && !this.hasFirst500) {
      // first500 user but hasn't redeemed offer
      this.showRedeemOffer = true;
    }
  }

  /**
   * Custom ad functionality
   */
  /*public update() {
    setTimeout(() => {
      this.changeIdx();
      this.update();
    }, 5000);
  }

  public changeIdx() {
    if (this.adIdx >= this.ads.length - 1) {
      // at the end
      this.adIdx = 0;
    } else {
      this.adIdx += 1;
    }
  }

  public closeAd(index: number) {
    this.ads.splice(index, 1);
    this.changeIdx();
  }*/

  // ---- end custom ad functionality

  // TOGGLES

  public closeCoins() {
    this.showCoins = false;
  }

  public closeShare() {
    this.showShare = false;
  }

  public closeRedeem() {
    this.showRedeemOffer = false;
  }
  public closeSafety() {
    this.showSafety = false;
  }

  public closeNewMobile() {
    this.showNewMobile = false;
  }

  public closeGiftCoins() {
    this.showGiftCoins = false;
  }
  public closePurchaseCoins() {
    this.showPurchaseCoins = false;
  }
  public closePayment() {
    this.showPayment = false;
  }

  public closeFAQ() {
    this.showFAQ = false;
  }

  public closeProfile() {
    this.showProfile = false;
  }

  public showAudio(user: MAFUser) {
    this.incomingUser = user;
    this.chatType = 'Audio';
    this.showVideoChat = true;
  }

  public onCoinGift(option: any) {
    this.closeGiftCoins();
  }

  public onCoinPayment(option: any) {
    this.selectedCoinPayment = option;
    this.goToModal('showPayment', 'showPurchaseCoins');
  }

  public onShowFaq() {
    this.showFAQ = true;
  }

  // user clicked in chat drawer - showing detail drawer
  public onShowUser( userId: string ) {
    this.selectedFriend = (this.selectedFriend !== userId) ? userId : '';
    if (this.selectedFriend) {
      const f = this.selectedFriend;
      this.selectedFriend = '';
      const friend = this.nearbyFriends.find((u) => u.uid === userId);
      // this.nearbyFriends.push(friend);
      if (!friend) {
        // friend doesn't exist on map
        this.getNearbyFriends();
      }
      this.selectedFriend = f;
    }
  }

  // show video popup (emit caputured from child), pass user
  public showVideo(user: MAFUser) {
    this.incomingUser = user;
    this.chatType = 'Video';
    this.showVideoChat = true;
  }

  public closeVideoChat() {
    this.showVideoChat = false;
    this.videoChatModal.endCall();
    // TODO: update to also end the call
  }

  public showBlockedUser(user: MAFUser) {
    this.incomingUser = user;
    this.showBlockUser = true;
  }

  public showReportUser(user: MAFUser) {
    this.incomingUser = user;
    this.showReportedUser = true;
  }

    public closeMeetupCreate() {
    this.meetupModal.close();
  }

  public closeMyMeetups() {
    this.$router.push('/dashboard');
  }

  public closeModal() {
    this.hasShown = true;
    this.verifyModal.close();
  }

  public closeSettings() {
    this.$router.push('/dashboard');
  }

  public closeChat() {
    this.showChat = false;
    if (this.route.toLowerCase().includes('messages')) {
      this.$router.push('/dashboard');
    }
  }

  // --- END TOGGLES ---

  public async saveProfile() {
    await this.profileModal.save();
    this.closeProfile();
  }

  public goToModal(where: string, close: string) {
    if (this.hasOwnProperty(close)) {
      // @ts-ignore
      this[close] = false;
    }

    // workaround for Mike's modal open/closes
    // unsure if refactoring would change other functionality
    if (where === 'showShare') {
      this.showShare = true;
    } else if (where === 'showAvatarCreator') {
      this.showAvatarCreator = true;
    } else if (where === 'showUploadModal') {
      this.showUploadModal = true;
    } else if (where === 'showPurchaseCoins') {
      this.showPurchaseCoins = true;
    } else if (where === 'showPayment') {
      this.showPayment = true;
    } else if (where === 'showGiftCoins') {
      this.showGiftCoins = true;
    } else if (where === 'showRedeemOffer') {
      this.showRedeemOffer = true;
    }
  }

  public showSnackbar(chatConnection: WebRTCRequest, chatType: string) {
    if (chatConnection && chatConnection.Sender) {
      this.$snackbar.open({
        message: `${chatConnection.Sender.name} is attempting to start a ${chatType} chat`,
        type: 'is-info',
        queue: true,
        position: 'is-bottom-left',
        indefinite: true,
        onAction: () => {
          this.showVideoChat = true;
          this.incomingConnection = chatConnection;
          this.incomingUser = chatConnection.Sender;
        },
      });
    }
  }

  @Watch('toConnections')
  public watchChatConnection() {
    const requested = this.toConnections.filter((connection) => connection.state === 'Requested');
    // if requests have changed (there's a new incoming)
    this.connectionRequests = this.toConnections.filter((connection) => connection.state === 'Requested');

    this.connectionRequests.forEach((cr) => {
      if (cr.Sender) {
        this.chatType = cr.isVideo ? 'Video' : 'Audio';
        this.showSnackbar(cr, this.chatType.toLowerCase());
      }
    });
  }

  // @Watch('currentLocation')
  // public watchCurrentLocation() {
    // const loc = this.convertMyLocToGeoPoint();
    // if (loc) {
    //   this.getTenClosestUsers(loc);
    // }
  // }

  public resetFriends() {
    this.nearbyFriends = [];
    if (this.radius !== 100 && this.limit !== 100) {
      this.radius = this.radius - 15;
      this.limit = this.limit - 50;

      this.getNearbyFriends();
    }
  }

  // on "Load More Friends" button click
  public loadMoreFriends() {
    this.nearbyFriends = [];
    this.radius = this.radius + 15;
    this.limit = this.limit + 50;

    this.getNearbyFriends();
  }

  public getGeohashRange(latitude: number, longitude: number, distance: number) {
    const lat = 0.0144927536231884; // degrees latitude per mile
    const lon = 0.0181818181818182; // degrees longitude per mile

    const lowerLat = latitude - lat * distance;
    const lowerLon = longitude - lon * distance;

    const upperLat = latitude + lat * distance;
    const upperLon = longitude + lon * distance;

    const lower = geohash.encode(lowerLat, lowerLon);
    const upper = geohash.encode(upperLat, upperLon);

    return {
      lower,
      upper,
    };
  }

  public async getNearbyFriends() {
    // const myHash = this.self.geohash;

    // check how many allUsers are in the DB so we know when to stop searching
    // const allUsersCount = (this.allUsers) ? this.allUsers.length : 0;
    if (this.self) {
      const position: GeoPoint = (this.self.location) ?
        this.self.location as GeoPoint : {latitude: 40.7128, longitude: 74.0060} as GeoPoint;

      const range = this.getGeohashRange(position.latitude, position.longitude, this.radius);
      this.unsub = await this.$firestore.collection('users')
        .where('signUpPhase', '==', -1)
        .orderBy('geohash')
        .where('geohash', '>=', range.lower)
        .where('geohash', '<=', range.upper)
        .limit(this.limit)
        .get().then((snapshot) => {
          // get all signed up users within a specific geohash range
          snapshot.docs.forEach((document) => {
            const data = new MAFUser(document.data());
            this.nearbyFriends.push(data);
          });

          const friend = this.allUsers.find((u) => u.uid === this.selectedFriend);
          if (friend) {
              this.nearbyFriends.push(friend);
          }
        });

      if (!this.self.location) {
          const conf = confirm('We were unable to capture your location, so we\'re showing you New York City, New York by default. Would you like help enabling your location? If so, please make sure popups are also enabled.');
          if (conf) {
            window.open('https://docs.buddypunch.com/en/articles/919258-how-to-enable-location-services-for-chrome-safari-and-android-ios-devices-gps-setting', '_newtab');
          }
        }
    } else {
      // alert('Your location was not captured correctly, so we\'re unable to show friends close to you.
      // Please make sure you\'ve enabled location sharing on your device.');
    }


    /**
     * Score compared users.
     * while we are currently scoring we may need to move this above the if
     * and remove people below an x amount matched
     */
    // commented out for testing purposes only
    // users.forEach((u: MAFUser ) => {
    //   if (this.self) {
    //     u.comparison = new Comparer(this.self, u);
    //   }
    // });
    // this.queryDistance = 5; // removed, use radius
    // this.setFriends(users);
  }

  @Watch('nearbyFriends')
  public unsubscribe() {
    // unsubscribe from snapshot user listener (avoiding loops), only pull data when we want it
    if (this.unsub && this.nearbyFriends.length > 0) {
      this.unsub();
    }
  }

  @Watch('friend')
  public toggleChatUser() {
    if (this.friend) {
      if (!this.showChat) {
        this.showChat = true;
      }
      this.chatBox.showChat();
    } else {
      this.chatBox.showUsers();
    }
  }

  @Watch('route')
  public determineChat() {
    if (this.route.toLowerCase().includes('messages')) {
      this.showChat = true;
      if (this.friend && this.chatBox) {
        this.chatBox.showChat();
      } else if (this.chatBox) {
        this.chatBox.showUsers();
      }
    }
    if (this.route.toLowerCase().includes('meetups')) {
      this.showCurrentMeetups = true;
    } else {
      this.showCurrentMeetups = false;
    }
    if (this.route.toLowerCase().includes('settings')) {
      this.showSettings = true;
    } else {
      this.showSettings = false;
    }
    if (this.route.toLowerCase().includes('showcoins')) {
      this.showCoins = true;
    }
    if (this.route.toLowerCase().includes('shareshow')) {
      this.showShare = true;
    }
    if (this.route.toLowerCase().includes('faqshow')) {
      this.showFAQ = true;
    }

    this.showProfile = (this.route.toLowerCase().includes('profileshow')) ? true : false;
  }

  public selectedUser(user: MAFUser) {
    this.setCurrentlyChattingWith(user);
    this.chatBox.showChat();
  }

}
